import { UserSortFieldEnum } from "~/__generated__/graphql"
import { useUserSort } from "./UserSortContext"
import { SortableColumnHeader } from "~/ui/SortableColumnHeader"

export const SortableColumn = ({
  field,
  children,
}: {
  field: UserSortFieldEnum
  children: React.ReactNode
}) => {
  const { sortField, sortDir, onSort } = useUserSort()

  return (
    <SortableColumnHeader
      onClick={() => onSort(field)}
      sortDir={sortDir}
      isActiveSort={field === sortField}
    >
      {children}
    </SortableColumnHeader>
  )
}
